import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, EffectCoverflow } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import './VideoCarousel.css';

const videos = [
  // {
  //     src: '/images/videos/birds-paradise-farm.mp4',
  //     title: "Bird's Paradise Farm",
  //     description: 'A serene farmhouse project blending nature with architecture'
  // },
  {
    src: '/images/videos/project-showcase.mp4',
    poster: '/images/videos/project-showcase-poster.jpg',
    title: "Bird's Paradise Farm",
    description: 'A serene farmhouse project blending nature with architecture',
  },
];

const VideoCarousel = () => {
  return (
    <section className="video-carousel-section">
      <div className="container">
        <h2 className="section-title">Our Projects in Motion</h2>
        <p className="section-subtitle">
          Experience our architectural designs through immersive video
          walkthroughs
        </p>
      </div>

      <div className="video-swiper-wrapper">
        <Swiper
          modules={[Navigation, Pagination, EffectCoverflow]}
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={1}
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 2,
            slideShadows: false,
          }}
          pagination={{
            clickable: true,
          }}
          navigation={true}
          breakpoints={{
            768: {
              slidesPerView: 1.5,
            },
            1024: {
              slidesPerView: 1.5,
            },
          }}
          className="video-swiper"
        >
          {videos.map((video, idx) => (
            <SwiperSlide key={idx}>
              <div className="video-slide">
                <video
                  src={video.src}
                  poster={video.poster}
                  controls
                  muted
                  playsInline
                  preload="none"
                  className="video-player"
                />
                <div className="video-info">
                  <h3 className="video-title">{video.title}</h3>
                  <p className="video-description">{video.description}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default VideoCarousel;
